<template>
<div class="addClientVue">
 <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-12">
                    <h1 class="h1 text-center">Clients</h1>
                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->

        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="col-md-6 col-md-offset-3">
                <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Client:</label>
                                <input type="text" class="form-control" placeholder="e.g. John Doe" v-validate="{ required: true}" name="name" v-model="addClientlist.display_name">
                                <span v-show="errors.has('name') && this.validation_err!=0" class="err-msg">{{ errors.first('name') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Max User:</label>
                                <div class="o-custom-dropdown">
                                    <select class="form-control" name="max_User" v-validate="{ required: true}" v-model="addClientlist.max_user">
                                                <option value="">— Select maximum users —</option>
                                                <option value="50">50 Free</option>                                                
                                                <option value="100">100</option>
                                                <option value="250">250</option>
                                                <option value="500">500</option>
                                                <option value="750">750</option>
                                                <option value="999999">Unlimited</option>
                                            </select>
                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </div>
                                <span v-show="errors.has('max_User') && this.validation_err!=0" class="err-msg">{{ errors.first('max_User') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Admin Contact:</label>
                                <input type="text" class="form-control" placeholder="Admin Contact name" v-validate="{ required: true}" name="contact_name" v-model="addClientlist.contact_person">
                                <span v-show="errors.has('contact_name') && this.validation_err!=0" class="err-msg">{{ errors.first('contact_name') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Email ID:</label>
                                <!-- <input type="email" class="form-control" placeholder="Email ID" v-validate="{ required: true}" name="email" v-model="addClientlist.email">
                                <span v-show="errors.has('email') && this.validation_err!=0" class="err-msg">{{ errors.first('email') }}</span> -->
                                <input @keyup="customValEmail($event, addClientlist.email)" v-model="addClientlist.email" type="text" class="form-control" placeholder="Primary Email" v-validate="'email|required'" name="email" data-vv-delay="500">
                                                                 
                                <span class="err-msg customError">Insert valid email adderess</span>
                                <span v-show="errors.has('email') && this.validation_err!=0" class="err-msg">{{ errors.first('email') }}</span>

                                <span v-if="emailExistNote == 1" class="customExisticon customExisticon--client o-customExisticon-tick"><i class="fa fa-check" aria-hidden="true"></i></span>
                                <span v-if="emailExistNote == 0" class="customExisticon customExisticon--client o-customExisticon-cross"><i class="fa fa-times" aria-hidden="true"></i></span>
                                <span class="custom-error-note o-customExisticon-cross" v-if="emailExistNote == 0">Email already exist</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Phone:</label>
                                <input type="number" class="form-control" placeholder="Enter phone number" v-validate="{ required: true}" name="phone" v-model="addClientlist.contact_phone">
                                <span v-show="errors.has('phone') && this.validation_err!=0" class="err-msg">{{ errors.first('phone') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Subdomain:</label>

                                <!-- <input type="text" class="form-control" placeholder="Enter subdomain" v-validate="{ required: true}" name="subdomain" v-model="addClientlist.subdomain">
                                <span v-show="errors.has('subdomain') && this.validation_err!=0" class="err-msg">{{ errors.first('subdomain') }}</span> -->

                           <input @keyup="customValSubDomain($event, addClientlist.subdomain)" type="text" class="form-control" placeholder="Enter subdomain" v-validate="{required: true}" name="subdomain" v-model="addClientlist.subdomain" data-vv-delay="500">
                                                                 
                                <span class="err-msg customError">Insert valid Sub Domain adderess</span>
                                <span v-show="errors.has('subdomain') && this.validation_err!=0" class="err-msg">{{ errors.first('subdomain') }}</span>

                                <span v-if="subDomainNote == 1" class="customExisticon customExisticon--client o-customExisticon-tick"><i class="fa fa-check" aria-hidden="true"></i></span>
                                <span v-if="subDomainNote == 0" class="customExisticon customExisticon--client o-customExisticon-cross"><i class="fa fa-times" aria-hidden="true"></i></span>
                                <span class="custom-error-note o-customExisticon-cross" v-if="subDomainNote == 0">Sub Domain already exist</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Billing Contact:</label>
                                <input type="text" class="form-control" placeholder="Add your billing contact name" v-validate="{ required: true}" name="billingContact" v-model="addClientlist.billing_contact">
                            </div>  
                        </div>
                    
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Billing Email:</label>
                                <input type="email" class="form-control" placeholder="Add your biling email" name="billingEmail" v-model="addClientlist.billing_email">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Notes:</label>
                                <textarea class="form-control u-border-radius-0" rows="3" placeholder="Enter notes here" v-model="addClientlist.note"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-center">
                                <ul class="o-filter-area">
                                    <li>
                                        <a href="javascript: void(0)" @click="backToList()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                    </li>
                                    <li>
                                        <a href="javascript: void(0)" @click="addClient()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
</div>

</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken'

            })
        },
        data() {
            return {
                validation_err: 0,
                emailExistNote: -1,
                subDomainNote: -1,
                addClientlist: {
                    display_name: '',
                    max_user: '',
                    email: '',
                    contact_person: '',
                    contact_phone: '',
                    note: '',
                    billing_contact: '',
                    billing_email: '',
                    subdomain: '',
                    url: '',
                    // settings: {
                    //     "sign-in-sheet": {},
                    //     "job-info-config": {},
                    //     "call-data-config": {},
                    //     "call-assignment-config": {}
                    // },
                    
                    settings:{
                        'call-assignment-config':{},
                        'call-data-config':{},
                        'job-info-config-future':{},
                        'job-info-config-past':{},
                        'job-type-future':{},
                        'job-type-past':{},
                        'notes-documents-config':'disabled',
                        'notification-config':{},
                        'sign-in-sheet':{}
                    }

                }
            }
        },
        created() {
            this.addClientlist.url = document.location.href.split('#')[0] + "#/resetPassword";
        },
        methods: {
            customValEmail(event, customEmailField) {
                if (customEmailField !== "") {
                    const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                    if (filter.test(customEmailField)) {
                        service.get('user/emailExists', {
                            'Authorization': this.userToken,
                            'email': this.addClientlist.email,
                        }).
                        then((res) => {
                            //console.log("Email Status", res.data.result);
                            this.emailExistNote = res.data.result;

                        }).catch((err) => {
                            console.log(err);
                            this.emailExistNote = false;
                        });
                        $(event.target).next(".customError").css("display", "none");
                    } else {
                        $(event.target).next(".customError").css("display", "block");
                    }
                } else {
                    $(event.target).next(".customError").css("display", "none");
                    this.emailExistNote = -1;
                }
            },
            customValSubDomain(event, customSubDomainField) {
                if (customSubDomainField !== "") {
                    service.get('user/subdomainExists', {
                        'Authorization': this.userToken,
                        'subdomain': this.addClientlist.subdomain,
                    }).
                    then((res) => {
                        //console.log("Email Status", res.data.result);
                        this.subDomainNote = res.data.result;

                    }).catch((err) => {
                        console.log(err);
                        this.subDomainNote = false;
                    });
                } else {
                    $(event.target).next(".customError").css("display", "none");
                    this.subDomainNote = -1;
                }



                /*if (customEmailField !== "") {

                    if (test(customEmailField)) {
                        service.get('user/emailExists', {
                            'Authorization': this.userToken,
                            'email': this.addClientlist.email,
                        }).
                        then((res) => {
                            //console.log("Email Status", res.data.result);
                            this.emailExistNote = res.data.result;

                        }).catch((err) => {
                            console.log(err);
                            this.emailExistNote = false;
                        });
                        $(event.target).next(".customError").css("display", "none");
                    } else {
                        $(event.target).next(".customError").css("display", "block");
                    }
                } else {
                    $(event.target).next(".customError").css("display", "none");
                    this.emailExistNote = -1;
                }*/

            },

            addClient() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        service.get('user/emailExists', {
                                'Authorization': this.userToken,
                                'email': this.addClientlist.email
                            })
                            .then((res) => {

                                if (res.data.result == 1) {
                                    service.post('client', this.addClientlist, {
                                            'Authorization': this.userToken
                                        })
                                        .then((newClients) => {

                                            this.$notify({
                                                title: this.$t('success'),
                                                message: 'Client Added Successfully.',
                                                type: 'success'
                                            });
                                            this.$router.push({
                                                'path': '/clientList'
                                            });

                                        }).catch((err) => {

                                            this.$message({
                                                type: 'error',
                                                message: 'Subdomain already exists'
                                            });
                                            this.addClientlist.subdomain = '';
                                        });

                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: 'Email already exists'
                                    });
                                    this.addClientlist.email = '';
                                }


                            }).catch((err) => {

                                console.log(err);
                            });

                    } else {
                        this.validation_err = 1;
                        console.log("error");
                    }
                });
            },
            backToList() {
                this.$router.push({
                    'path': '/clientList'
                });
            }

        }
    }

</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/superAdmin/addClient.vue